import React from 'react'
import PageContent from 'components/common/PageContent'
import OrganisationsTable from 'components/organisation/organisations/OrganisationsTable'

export default function Organisations(props) {
    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "Organisations"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <OrganisationsTable/>
        </PageContent>
    );
}